var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.102,
    height: 20.09,
    viewBox: "0 0 16.102 20.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .prof-cls-1, .prof-cls-2 {\n        fill: none;\n        stroke: #a7a7be;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.2px;\n      }\n\n      .prof-cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(0.6 0.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    className: "prof-cls-1",
    cx: 4.695,
    cy: 4.695,
    r: 4.695,
    transform: "translate(2.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "prof-cls-2",
    d: "M4,18.649a2.177,2.177,0,0,1,.216-.954A3.972,3.972,0,0,1,6.986,16.1a16.487,16.487,0,0,1,2.3-.324,24.606,24.606,0,0,1,4.309,0,16.685,16.685,0,0,1,2.3.324c1.052.216,2.321.648,2.77,1.592a2.231,2.231,0,0,1,0,1.916c-.45.944-1.718,1.376-2.77,1.583a15.45,15.45,0,0,1-2.3.333,25.378,25.378,0,0,1-3.508.054,3.989,3.989,0,0,1-.8-.054A15.15,15.15,0,0,1,7,21.195a3.8,3.8,0,0,1-2.779-1.583A2.24,2.24,0,0,1,4,18.649Z",
    transform: "translate(-4 -2.728)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.6ed443b6.svg";
export { ForwardRef as ReactComponent };